module.exports = __webpack_public_path__ + "img/Richpanel.c4d7e98f.svg";